
const demoTopTracks = {
  "items": [
    {
      "album": {
        "album_type": "SINGLE",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/4Uc8Dsxct0oMqx0P6i60ea"
            },
            "href": "https://api.spotify.com/v1/artists/4Uc8Dsxct0oMqx0P6i60ea",
            "id": "4Uc8Dsxct0oMqx0P6i60ea",
            "name": "Conan Gray",
            "type": "artist",
            "uri": "spotify:artist:4Uc8Dsxct0oMqx0P6i60ea"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/6npBFQje5ZenFSLErcNflE"
        },
        "href": "https://api.spotify.com/v1/albums/6npBFQje5ZenFSLErcNflE",
        "id": "6npBFQje5ZenFSLErcNflE",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b2734a290161cb28ec9c78634e13",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e024a290161cb28ec9c78634e13",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d000048514a290161cb28ec9c78634e13",
            "width": 64
          }
        ],
        "name": "Telepath",
        "release_date": "2021-10-29",
        "release_date_precision": "day",
        "total_tracks": 1,
        "type": "album",
        "uri": "spotify:album:6npBFQje5ZenFSLErcNflE"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/4Uc8Dsxct0oMqx0P6i60ea"
          },
          "href": "https://api.spotify.com/v1/artists/4Uc8Dsxct0oMqx0P6i60ea",
          "id": "4Uc8Dsxct0oMqx0P6i60ea",
          "name": "Conan Gray",
          "type": "artist",
          "uri": "spotify:artist:4Uc8Dsxct0oMqx0P6i60ea"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 194973,
      "explicit": false,
      "external_ids": {
        "isrc": "USUM72119694"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/3Z39gbqdaGL3WJXBG0gcuE"
      },
      "href": "https://api.spotify.com/v1/tracks/3Z39gbqdaGL3WJXBG0gcuE",
      "id": "3Z39gbqdaGL3WJXBG0gcuE",
      "is_local": false,
      "name": "Telepath",
      "popularity": 78,
      "preview_url": "https://p.scdn.co/mp3-preview/e0d703aed0d65ce4159de0bc57bb0be27713a0df?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 1,
      "type": "track",
      "uri": "spotify:track:3Z39gbqdaGL3WJXBG0gcuE"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/34v5MVKeQnIo0CWYMbbrPf"
            },
            "href": "https://api.spotify.com/v1/artists/34v5MVKeQnIo0CWYMbbrPf",
            "id": "34v5MVKeQnIo0CWYMbbrPf",
            "name": "John Newman",
            "type": "artist",
            "uri": "spotify:artist:34v5MVKeQnIo0CWYMbbrPf"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/2Bgfdyrywv3KEe0WwZdb0V"
        },
        "href": "https://api.spotify.com/v1/albums/2Bgfdyrywv3KEe0WwZdb0V",
        "id": "2Bgfdyrywv3KEe0WwZdb0V",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b273b38d10a0f9eabec693d8f96e",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e02b38d10a0f9eabec693d8f96e",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d00004851b38d10a0f9eabec693d8f96e",
            "width": 64
          }
        ],
        "name": "Tribute",
        "release_date": "2013-01-01",
        "release_date_precision": "day",
        "total_tracks": 11,
        "type": "album",
        "uri": "spotify:album:2Bgfdyrywv3KEe0WwZdb0V"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/34v5MVKeQnIo0CWYMbbrPf"
          },
          "href": "https://api.spotify.com/v1/artists/34v5MVKeQnIo0CWYMbbrPf",
          "id": "34v5MVKeQnIo0CWYMbbrPf",
          "name": "John Newman",
          "type": "artist",
          "uri": "spotify:artist:34v5MVKeQnIo0CWYMbbrPf"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 222218,
      "explicit": false,
      "external_ids": {
        "isrc": "GBUM71302727"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/3rUG2H2MCyZ8elpVB2jA8p"
      },
      "href": "https://api.spotify.com/v1/tracks/3rUG2H2MCyZ8elpVB2jA8p",
      "id": "3rUG2H2MCyZ8elpVB2jA8p",
      "is_local": false,
      "name": "Cheating",
      "popularity": 53,
      "preview_url": "https://p.scdn.co/mp3-preview/be625226ea0123a24afb71aecd888f45bfb9a873?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 7,
      "type": "track",
      "uri": "spotify:track:3rUG2H2MCyZ8elpVB2jA8p"
    },
    {
      "album": {
        "album_type": "SINGLE",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/0Y5tJX1MQlPlqiwlOH1tJY"
            },
            "href": "https://api.spotify.com/v1/artists/0Y5tJX1MQlPlqiwlOH1tJY",
            "id": "0Y5tJX1MQlPlqiwlOH1tJY",
            "name": "Travis Scott",
            "type": "artist",
            "uri": "spotify:artist:0Y5tJX1MQlPlqiwlOH1tJY"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/5FB5E1fwFeVqpz2CCzRSve"
        },
        "href": "https://api.spotify.com/v1/albums/5FB5E1fwFeVqpz2CCzRSve",
        "id": "5FB5E1fwFeVqpz2CCzRSve",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b273eba68473429f9f4eaf1943d0",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e02eba68473429f9f4eaf1943d0",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d00004851eba68473429f9f4eaf1943d0",
            "width": 64
          }
        ],
        "name": "ESCAPE PLAN / MAFIA",
        "release_date": "2021-11-05",
        "release_date_precision": "day",
        "total_tracks": 2,
        "type": "album",
        "uri": "spotify:album:5FB5E1fwFeVqpz2CCzRSve"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/0Y5tJX1MQlPlqiwlOH1tJY"
          },
          "href": "https://api.spotify.com/v1/artists/0Y5tJX1MQlPlqiwlOH1tJY",
          "id": "0Y5tJX1MQlPlqiwlOH1tJY",
          "name": "Travis Scott",
          "type": "artist",
          "uri": "spotify:artist:0Y5tJX1MQlPlqiwlOH1tJY"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 149610,
      "explicit": true,
      "external_ids": {
        "isrc": "USSM12104018"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/4R67rQNSbbsR4TdUVOIdez"
      },
      "href": "https://api.spotify.com/v1/tracks/4R67rQNSbbsR4TdUVOIdez",
      "id": "4R67rQNSbbsR4TdUVOIdez",
      "is_local": false,
      "name": "ESCAPE PLAN",
      "popularity": 86,
      "preview_url": "https://p.scdn.co/mp3-preview/8047f12bb2f41fb5fe9286400f55798cb79e15b6?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 1,
      "type": "track",
      "uri": "spotify:track:4R67rQNSbbsR4TdUVOIdez"
    },
    {
      "album": {
        "album_type": "SINGLE",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/5H6xmHXjsq98NLbEjuE29f"
            },
            "href": "https://api.spotify.com/v1/artists/5H6xmHXjsq98NLbEjuE29f",
            "id": "5H6xmHXjsq98NLbEjuE29f",
            "name": "NEIKED",
            "type": "artist",
            "uri": "spotify:artist:5H6xmHXjsq98NLbEjuE29f"
          },
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/1BEUkE2CSUgHTLSBMZdnFB"
            },
            "href": "https://api.spotify.com/v1/artists/1BEUkE2CSUgHTLSBMZdnFB",
            "id": "1BEUkE2CSUgHTLSBMZdnFB",
            "name": "Mae Muller",
            "type": "artist",
            "uri": "spotify:artist:1BEUkE2CSUgHTLSBMZdnFB"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/2wcv0lHk5fUYyNGKugGa7q"
        },
        "href": "https://api.spotify.com/v1/albums/2wcv0lHk5fUYyNGKugGa7q",
        "id": "2wcv0lHk5fUYyNGKugGa7q",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b2736b742298f7f36717855c4caf",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e026b742298f7f36717855c4caf",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d000048516b742298f7f36717855c4caf",
            "width": 64
          }
        ],
        "name": "Better Days (NEIKED x Mae Muller x Polo G)",
        "release_date": "2021-09-24",
        "release_date_precision": "day",
        "total_tracks": 1,
        "type": "album",
        "uri": "spotify:album:2wcv0lHk5fUYyNGKugGa7q"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/5H6xmHXjsq98NLbEjuE29f"
          },
          "href": "https://api.spotify.com/v1/artists/5H6xmHXjsq98NLbEjuE29f",
          "id": "5H6xmHXjsq98NLbEjuE29f",
          "name": "NEIKED",
          "type": "artist",
          "uri": "spotify:artist:5H6xmHXjsq98NLbEjuE29f"
        },
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/1BEUkE2CSUgHTLSBMZdnFB"
          },
          "href": "https://api.spotify.com/v1/artists/1BEUkE2CSUgHTLSBMZdnFB",
          "id": "1BEUkE2CSUgHTLSBMZdnFB",
          "name": "Mae Muller",
          "type": "artist",
          "uri": "spotify:artist:1BEUkE2CSUgHTLSBMZdnFB"
        },
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/6AgTAQt8XS6jRWi4sX7w49"
          },
          "href": "https://api.spotify.com/v1/artists/6AgTAQt8XS6jRWi4sX7w49",
          "id": "6AgTAQt8XS6jRWi4sX7w49",
          "name": "Polo G",
          "type": "artist",
          "uri": "spotify:artist:6AgTAQt8XS6jRWi4sX7w49"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 160656,
      "explicit": false,
      "external_ids": {
        "isrc": "GBUM72106057"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/6f5ExP43esnvdKPddwKXJH"
      },
      "href": "https://api.spotify.com/v1/tracks/6f5ExP43esnvdKPddwKXJH",
      "id": "6f5ExP43esnvdKPddwKXJH",
      "is_local": false,
      "name": "Better Days (NEIKED x Mae Muller x Polo G)",
      "popularity": 91,
      "preview_url": "https://p.scdn.co/mp3-preview/14defc0a6cc8ddf8e855f28dc6238e2851996634?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 1,
      "type": "track",
      "uri": "spotify:track:6f5ExP43esnvdKPddwKXJH"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4"
            },
            "href": "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
            "id": "3TVXtAsR1Inumwj472S9r4",
            "name": "Drake",
            "type": "artist",
            "uri": "spotify:artist:3TVXtAsR1Inumwj472S9r4"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/3SpBlxme9WbeQdI9kx7KAV"
        },
        "href": "https://api.spotify.com/v1/albums/3SpBlxme9WbeQdI9kx7KAV",
        "id": "3SpBlxme9WbeQdI9kx7KAV",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b273cd945b4e3de57edd28481a3f",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e02cd945b4e3de57edd28481a3f",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d00004851cd945b4e3de57edd28481a3f",
            "width": 64
          }
        ],
        "name": "Certified Lover Boy",
        "release_date": "2021-09-03",
        "release_date_precision": "day",
        "total_tracks": 21,
        "type": "album",
        "uri": "spotify:album:3SpBlxme9WbeQdI9kx7KAV"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4"
          },
          "href": "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
          "id": "3TVXtAsR1Inumwj472S9r4",
          "name": "Drake",
          "type": "artist",
          "uri": "spotify:artist:3TVXtAsR1Inumwj472S9r4"
        },
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/1RyvyyTE3xzB2ZywiAwp0i"
          },
          "href": "https://api.spotify.com/v1/artists/1RyvyyTE3xzB2ZywiAwp0i",
          "id": "1RyvyyTE3xzB2ZywiAwp0i",
          "name": "Future",
          "type": "artist",
          "uri": "spotify:artist:1RyvyyTE3xzB2ZywiAwp0i"
        },
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/50co4Is1HCEo8bhOyUWKpn"
          },
          "href": "https://api.spotify.com/v1/artists/50co4Is1HCEo8bhOyUWKpn",
          "id": "50co4Is1HCEo8bhOyUWKpn",
          "name": "Young Thug",
          "type": "artist",
          "uri": "spotify:artist:50co4Is1HCEo8bhOyUWKpn"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 257604,
      "explicit": true,
      "external_ids": {
        "isrc": "USUG12104403"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/0k1WUmIRnG3xU6fvvDVfRG"
      },
      "href": "https://api.spotify.com/v1/tracks/0k1WUmIRnG3xU6fvvDVfRG",
      "id": "0k1WUmIRnG3xU6fvvDVfRG",
      "is_local": false,
      "name": "Way 2 Sexy (with Future & Young Thug)",
      "popularity": 90,
      "preview_url": "https://p.scdn.co/mp3-preview/e4a1bbc010e934bea0f4343c68d8c5fefecd0a76?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 7,
      "type": "track",
      "uri": "spotify:track:0k1WUmIRnG3xU6fvvDVfRG"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/0fTav4sBLmYOAzKuJw0grL"
            },
            "href": "https://api.spotify.com/v1/artists/0fTav4sBLmYOAzKuJw0grL",
            "id": "0fTav4sBLmYOAzKuJw0grL",
            "name": "Mac Ayres",
            "type": "artist",
            "uri": "spotify:artist:0fTav4sBLmYOAzKuJw0grL"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/0fjJoEGBF5hxlv862DjVx5"
        },
        "href": "https://api.spotify.com/v1/albums/0fjJoEGBF5hxlv862DjVx5",
        "id": "0fjJoEGBF5hxlv862DjVx5",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b273bde4f0bab3a774a3351b8b40",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e02bde4f0bab3a774a3351b8b40",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d00004851bde4f0bab3a774a3351b8b40",
            "width": 64
          }
        ],
        "name": "Magic 8ball",
        "release_date": "2021-01-08",
        "release_date_precision": "day",
        "total_tracks": 8,
        "type": "album",
        "uri": "spotify:album:0fjJoEGBF5hxlv862DjVx5"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/0fTav4sBLmYOAzKuJw0grL"
          },
          "href": "https://api.spotify.com/v1/artists/0fTav4sBLmYOAzKuJw0grL",
          "id": "0fTav4sBLmYOAzKuJw0grL",
          "name": "Mac Ayres",
          "type": "artist",
          "uri": "spotify:artist:0fTav4sBLmYOAzKuJw0grL"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 263554,
      "explicit": false,
      "external_ids": {
        "isrc": "QZNWZ2018995"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/4Z5Bwienk09FUgwsMlsPwJ"
      },
      "href": "https://api.spotify.com/v1/tracks/4Z5Bwienk09FUgwsMlsPwJ",
      "id": "4Z5Bwienk09FUgwsMlsPwJ",
      "is_local": false,
      "name": "Where U Goin' Tonight?",
      "popularity": 61,
      "preview_url": "https://p.scdn.co/mp3-preview/c1b2f81e7044b2ba77f109f973a1d2d70fa43fa2?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 7,
      "type": "track",
      "uri": "spotify:track:4Z5Bwienk09FUgwsMlsPwJ"
    },
    {
      "album": {
        "album_type": "SINGLE",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/1Xyo4u8uXC1ZmMpatF05PJ"
            },
            "href": "https://api.spotify.com/v1/artists/1Xyo4u8uXC1ZmMpatF05PJ",
            "id": "1Xyo4u8uXC1ZmMpatF05PJ",
            "name": "The Weeknd",
            "type": "artist",
            "uri": "spotify:artist:1Xyo4u8uXC1ZmMpatF05PJ"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/2MouaLzzY4HnsUYJYSgu2o"
        },
        "href": "https://api.spotify.com/v1/albums/2MouaLzzY4HnsUYJYSgu2o",
        "id": "2MouaLzzY4HnsUYJYSgu2o",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b2733186924a372e69b3412e96ba",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e023186924a372e69b3412e96ba",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d000048513186924a372e69b3412e96ba",
            "width": 64
          }
        ],
        "name": "In Your Eyes (Remix)",
        "release_date": "2020-10-16",
        "release_date_precision": "day",
        "total_tracks": 1,
        "type": "album",
        "uri": "spotify:album:2MouaLzzY4HnsUYJYSgu2o"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/1Xyo4u8uXC1ZmMpatF05PJ"
          },
          "href": "https://api.spotify.com/v1/artists/1Xyo4u8uXC1ZmMpatF05PJ",
          "id": "1Xyo4u8uXC1ZmMpatF05PJ",
          "name": "The Weeknd",
          "type": "artist",
          "uri": "spotify:artist:1Xyo4u8uXC1ZmMpatF05PJ"
        },
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/6I3M904Y9IwgDjrQ9pANiB"
          },
          "href": "https://api.spotify.com/v1/artists/6I3M904Y9IwgDjrQ9pANiB",
          "id": "6I3M904Y9IwgDjrQ9pANiB",
          "name": "Kenny G",
          "type": "artist",
          "uri": "spotify:artist:6I3M904Y9IwgDjrQ9pANiB"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 256551,
      "explicit": false,
      "external_ids": {
        "isrc": "USUG12003955"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/1SySkCqhEG6Z68o2n07Bsr"
      },
      "href": "https://api.spotify.com/v1/tracks/1SySkCqhEG6Z68o2n07Bsr",
      "id": "1SySkCqhEG6Z68o2n07Bsr",
      "is_local": false,
      "name": "In Your Eyes (feat. Kenny G) - Remix",
      "popularity": 58,
      "preview_url": "https://p.scdn.co/mp3-preview/6f3af48693c99261e601ebde7c6d9c740ddced90?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 1,
      "type": "track",
      "uri": "spotify:track:1SySkCqhEG6Z68o2n07Bsr"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4"
            },
            "href": "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
            "id": "3TVXtAsR1Inumwj472S9r4",
            "name": "Drake",
            "type": "artist",
            "uri": "spotify:artist:3TVXtAsR1Inumwj472S9r4"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/3SpBlxme9WbeQdI9kx7KAV"
        },
        "href": "https://api.spotify.com/v1/albums/3SpBlxme9WbeQdI9kx7KAV",
        "id": "3SpBlxme9WbeQdI9kx7KAV",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b273cd945b4e3de57edd28481a3f",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e02cd945b4e3de57edd28481a3f",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d00004851cd945b4e3de57edd28481a3f",
            "width": 64
          }
        ],
        "name": "Certified Lover Boy",
        "release_date": "2021-09-03",
        "release_date_precision": "day",
        "total_tracks": 21,
        "type": "album",
        "uri": "spotify:album:3SpBlxme9WbeQdI9kx7KAV"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4"
          },
          "href": "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
          "id": "3TVXtAsR1Inumwj472S9r4",
          "name": "Drake",
          "type": "artist",
          "uri": "spotify:artist:3TVXtAsR1Inumwj472S9r4"
        },
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/687cZJR45JO7jhk1LHIbgq"
          },
          "href": "https://api.spotify.com/v1/artists/687cZJR45JO7jhk1LHIbgq",
          "id": "687cZJR45JO7jhk1LHIbgq",
          "name": "Tems",
          "type": "artist",
          "uri": "spotify:artist:687cZJR45JO7jhk1LHIbgq"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 192417,
      "explicit": true,
      "external_ids": {
        "isrc": "USUG12104412"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/08XWh5c0BMyD1nKVxxl91z"
      },
      "href": "https://api.spotify.com/v1/tracks/08XWh5c0BMyD1nKVxxl91z",
      "id": "08XWh5c0BMyD1nKVxxl91z",
      "is_local": false,
      "name": "Fountains (with Tems)",
      "popularity": 77,
      "preview_url": "https://p.scdn.co/mp3-preview/9b793e9f62d310ded78a112d3e82fbcbc87c9133?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 16,
      "type": "track",
      "uri": "spotify:track:08XWh5c0BMyD1nKVxxl91z"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4"
            },
            "href": "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
            "id": "3TVXtAsR1Inumwj472S9r4",
            "name": "Drake",
            "type": "artist",
            "uri": "spotify:artist:3TVXtAsR1Inumwj472S9r4"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/3SpBlxme9WbeQdI9kx7KAV"
        },
        "href": "https://api.spotify.com/v1/albums/3SpBlxme9WbeQdI9kx7KAV",
        "id": "3SpBlxme9WbeQdI9kx7KAV",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b273cd945b4e3de57edd28481a3f",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e02cd945b4e3de57edd28481a3f",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d00004851cd945b4e3de57edd28481a3f",
            "width": 64
          }
        ],
        "name": "Certified Lover Boy",
        "release_date": "2021-09-03",
        "release_date_precision": "day",
        "total_tracks": 21,
        "type": "album",
        "uri": "spotify:album:3SpBlxme9WbeQdI9kx7KAV"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/3TVXtAsR1Inumwj472S9r4"
          },
          "href": "https://api.spotify.com/v1/artists/3TVXtAsR1Inumwj472S9r4",
          "id": "3TVXtAsR1Inumwj472S9r4",
          "name": "Drake",
          "type": "artist",
          "uri": "spotify:artist:3TVXtAsR1Inumwj472S9r4"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 204346,
      "explicit": true,
      "external_ids": {
        "isrc": "USUG12104408"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/2tUL6dZf1mywCj5WvCPZw6"
      },
      "href": "https://api.spotify.com/v1/tracks/2tUL6dZf1mywCj5WvCPZw6",
      "id": "2tUL6dZf1mywCj5WvCPZw6",
      "is_local": false,
      "name": "No Friends In The Industry",
      "popularity": 81,
      "preview_url": "https://p.scdn.co/mp3-preview/13ff7fd123e1648f074abe55851e2a25e0758f4a?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 12,
      "type": "track",
      "uri": "spotify:track:2tUL6dZf1mywCj5WvCPZw6"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/5cj0lLjcoR7YOSnhnX0Po5"
            },
            "href": "https://api.spotify.com/v1/artists/5cj0lLjcoR7YOSnhnX0Po5",
            "id": "5cj0lLjcoR7YOSnhnX0Po5",
            "name": "Doja Cat",
            "type": "artist",
            "uri": "spotify:artist:5cj0lLjcoR7YOSnhnX0Po5"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/1nAQbHeOWTfQzbOoFrvndW"
        },
        "href": "https://api.spotify.com/v1/albums/1nAQbHeOWTfQzbOoFrvndW",
        "id": "1nAQbHeOWTfQzbOoFrvndW",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b2734df3245f26298a1579ecc321",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e024df3245f26298a1579ecc321",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d000048514df3245f26298a1579ecc321",
            "width": 64
          }
        ],
        "name": "Planet Her",
        "release_date": "2021-06-25",
        "release_date_precision": "day",
        "total_tracks": 14,
        "type": "album",
        "uri": "spotify:album:1nAQbHeOWTfQzbOoFrvndW"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/5cj0lLjcoR7YOSnhnX0Po5"
          },
          "href": "https://api.spotify.com/v1/artists/5cj0lLjcoR7YOSnhnX0Po5",
          "id": "5cj0lLjcoR7YOSnhnX0Po5",
          "name": "Doja Cat",
          "type": "artist",
          "uri": "spotify:artist:5cj0lLjcoR7YOSnhnX0Po5"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 138293,
      "explicit": true,
      "external_ids": {
        "isrc": "USRC12101535"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/0W6I02J9xcqK8MtSeosEXb"
      },
      "href": "https://api.spotify.com/v1/tracks/0W6I02J9xcqK8MtSeosEXb",
      "id": "0W6I02J9xcqK8MtSeosEXb",
      "is_local": false,
      "name": "Get Into It (Yuh)",
      "popularity": 89,
      "preview_url": "https://p.scdn.co/mp3-preview/9e8520d5158525ba24e8b1ca91f03febb3987733?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 4,
      "type": "track",
      "uri": "spotify:track:0W6I02J9xcqK8MtSeosEXb"
    },
    {
      "album": {
        "album_type": "SINGLE",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/63XBtGSEZINSyXylZxEUbv"
            },
            "href": "https://api.spotify.com/v1/artists/63XBtGSEZINSyXylZxEUbv",
            "id": "63XBtGSEZINSyXylZxEUbv",
            "name": "Victoria Monét",
            "type": "artist",
            "uri": "spotify:artist:63XBtGSEZINSyXylZxEUbv"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/6PVTVZo9iYmpcQucpIN9Kr"
        },
        "href": "https://api.spotify.com/v1/albums/6PVTVZo9iYmpcQucpIN9Kr",
        "id": "6PVTVZo9iYmpcQucpIN9Kr",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b2738ba64df86793ffdb09cb4f5b",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e028ba64df86793ffdb09cb4f5b",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d000048518ba64df86793ffdb09cb4f5b",
            "width": 64
          }
        ],
        "name": "Coastin’",
        "release_date": "2021-08-05",
        "release_date_precision": "day",
        "total_tracks": 1,
        "type": "album",
        "uri": "spotify:album:6PVTVZo9iYmpcQucpIN9Kr"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/63XBtGSEZINSyXylZxEUbv"
          },
          "href": "https://api.spotify.com/v1/artists/63XBtGSEZINSyXylZxEUbv",
          "id": "63XBtGSEZINSyXylZxEUbv",
          "name": "Victoria Monét",
          "type": "artist",
          "uri": "spotify:artist:63XBtGSEZINSyXylZxEUbv"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 175319,
      "explicit": true,
      "external_ids": {
        "isrc": "US23A1536898"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/1IjeGPU5hqHlJpm00zObN7"
      },
      "href": "https://api.spotify.com/v1/tracks/1IjeGPU5hqHlJpm00zObN7",
      "id": "1IjeGPU5hqHlJpm00zObN7",
      "is_local": false,
      "name": "Coastin’",
      "popularity": 70,
      "preview_url": "https://p.scdn.co/mp3-preview/1d207a352d38e12469d93159be93733c15a966bb?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 1,
      "type": "track",
      "uri": "spotify:track:1IjeGPU5hqHlJpm00zObN7"
    },
    {
      "album": {
        "album_type": "SINGLE",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/0Y5tJX1MQlPlqiwlOH1tJY"
            },
            "href": "https://api.spotify.com/v1/artists/0Y5tJX1MQlPlqiwlOH1tJY",
            "id": "0Y5tJX1MQlPlqiwlOH1tJY",
            "name": "Travis Scott",
            "type": "artist",
            "uri": "spotify:artist:0Y5tJX1MQlPlqiwlOH1tJY"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/5FB5E1fwFeVqpz2CCzRSve"
        },
        "href": "https://api.spotify.com/v1/albums/5FB5E1fwFeVqpz2CCzRSve",
        "id": "5FB5E1fwFeVqpz2CCzRSve",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b273eba68473429f9f4eaf1943d0",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e02eba68473429f9f4eaf1943d0",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d00004851eba68473429f9f4eaf1943d0",
            "width": 64
          }
        ],
        "name": "ESCAPE PLAN / MAFIA",
        "release_date": "2021-11-05",
        "release_date_precision": "day",
        "total_tracks": 2,
        "type": "album",
        "uri": "spotify:album:5FB5E1fwFeVqpz2CCzRSve"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/0Y5tJX1MQlPlqiwlOH1tJY"
          },
          "href": "https://api.spotify.com/v1/artists/0Y5tJX1MQlPlqiwlOH1tJY",
          "id": "0Y5tJX1MQlPlqiwlOH1tJY",
          "name": "Travis Scott",
          "type": "artist",
          "uri": "spotify:artist:0Y5tJX1MQlPlqiwlOH1tJY"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 240000,
      "explicit": true,
      "external_ids": {
        "isrc": "USSM12108561"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/08F16baYbciTva9P4BvpiI"
      },
      "href": "https://api.spotify.com/v1/tracks/08F16baYbciTva9P4BvpiI",
      "id": "08F16baYbciTva9P4BvpiI",
      "is_local": false,
      "name": "MAFIA",
      "popularity": 83,
      "preview_url": "https://p.scdn.co/mp3-preview/0ecb2d512d77b4c379bd347f6ff32c1436b032b9?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 2,
      "type": "track",
      "uri": "spotify:track:08F16baYbciTva9P4BvpiI"
    },
    {
      "album": {
        "album_type": "SINGLE",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/6M2wZ9GZgrQXHCFfjv46we"
            },
            "href": "https://api.spotify.com/v1/artists/6M2wZ9GZgrQXHCFfjv46we",
            "id": "6M2wZ9GZgrQXHCFfjv46we",
            "name": "Dua Lipa",
            "type": "artist",
            "uri": "spotify:artist:6M2wZ9GZgrQXHCFfjv46we"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/3aKLu3wgh654EA1iagDS2y"
        },
        "href": "https://api.spotify.com/v1/albums/3aKLu3wgh654EA1iagDS2y",
        "id": "3aKLu3wgh654EA1iagDS2y",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b27349e213de508a935b0038b205",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e0249e213de508a935b0038b205",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d0000485149e213de508a935b0038b205",
            "width": 64
          }
        ],
        "name": "Love Again",
        "release_date": "2021-06-04",
        "release_date_precision": "day",
        "total_tracks": 1,
        "type": "album",
        "uri": "spotify:album:3aKLu3wgh654EA1iagDS2y"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/6M2wZ9GZgrQXHCFfjv46we"
          },
          "href": "https://api.spotify.com/v1/artists/6M2wZ9GZgrQXHCFfjv46we",
          "id": "6M2wZ9GZgrQXHCFfjv46we",
          "name": "Dua Lipa",
          "type": "artist",
          "uri": "spotify:artist:6M2wZ9GZgrQXHCFfjv46we"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 258004,
      "explicit": false,
      "external_ids": {
        "isrc": "GBAHT1901302"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/3cbE0k4dUtvDJhyHjjuDPz"
      },
      "href": "https://api.spotify.com/v1/tracks/3cbE0k4dUtvDJhyHjjuDPz",
      "id": "3cbE0k4dUtvDJhyHjjuDPz",
      "is_local": false,
      "name": "Love Again",
      "popularity": 61,
      "preview_url": "https://p.scdn.co/mp3-preview/71cb81676426196ac9cb23c94c16de85eb230ddc?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 1,
      "type": "track",
      "uri": "spotify:track:3cbE0k4dUtvDJhyHjjuDPz"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/5vBSrE1xujD2FXYRarbAXc"
            },
            "href": "https://api.spotify.com/v1/artists/5vBSrE1xujD2FXYRarbAXc",
            "id": "5vBSrE1xujD2FXYRarbAXc",
            "name": "Years & Years",
            "type": "artist",
            "uri": "spotify:artist:5vBSrE1xujD2FXYRarbAXc"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/1OUGPngAngAxjliRlrAc6v"
        },
        "href": "https://api.spotify.com/v1/albums/1OUGPngAngAxjliRlrAc6v",
        "id": "1OUGPngAngAxjliRlrAc6v",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b2739f1764fbbd2ddd22efbf1e8c",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e029f1764fbbd2ddd22efbf1e8c",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d000048519f1764fbbd2ddd22efbf1e8c",
            "width": 64
          }
        ],
        "name": "Palo Santo (Deluxe)",
        "release_date": "2019-02-14",
        "release_date_precision": "day",
        "total_tracks": 16,
        "type": "album",
        "uri": "spotify:album:1OUGPngAngAxjliRlrAc6v"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/5vBSrE1xujD2FXYRarbAXc"
          },
          "href": "https://api.spotify.com/v1/artists/5vBSrE1xujD2FXYRarbAXc",
          "id": "5vBSrE1xujD2FXYRarbAXc",
          "name": "Years & Years",
          "type": "artist",
          "uri": "spotify:artist:5vBSrE1xujD2FXYRarbAXc"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 195680,
      "explicit": false,
      "external_ids": {
        "isrc": "GBUM71801548"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/02CH3KEpNtFgN4ItgqZdbG"
      },
      "href": "https://api.spotify.com/v1/tracks/02CH3KEpNtFgN4ItgqZdbG",
      "id": "02CH3KEpNtFgN4ItgqZdbG",
      "is_local": false,
      "name": "Don't Panic",
      "popularity": 42,
      "preview_url": "https://p.scdn.co/mp3-preview/15edbbc2f150b7b83ed2af9ce889cb6f27fbc229?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 15,
      "type": "track",
      "uri": "spotify:track:02CH3KEpNtFgN4ItgqZdbG"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/0knGpCTbmG4ctl1wzYRZs4"
            },
            "href": "https://api.spotify.com/v1/artists/0knGpCTbmG4ctl1wzYRZs4",
            "id": "0knGpCTbmG4ctl1wzYRZs4",
            "name": "Dijon",
            "type": "artist",
            "uri": "spotify:artist:0knGpCTbmG4ctl1wzYRZs4"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/4E691gbRgo2Zb6ToII2DWO"
        },
        "href": "https://api.spotify.com/v1/albums/4E691gbRgo2Zb6ToII2DWO",
        "id": "4E691gbRgo2Zb6ToII2DWO",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b273a68442f97c3ad2dcba0beae6",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e02a68442f97c3ad2dcba0beae6",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d00004851a68442f97c3ad2dcba0beae6",
            "width": 64
          }
        ],
        "name": "Absolutely",
        "release_date": "2021-11-05",
        "release_date_precision": "day",
        "total_tracks": 12,
        "type": "album",
        "uri": "spotify:album:4E691gbRgo2Zb6ToII2DWO"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/0knGpCTbmG4ctl1wzYRZs4"
          },
          "href": "https://api.spotify.com/v1/artists/0knGpCTbmG4ctl1wzYRZs4",
          "id": "0knGpCTbmG4ctl1wzYRZs4",
          "name": "Dijon",
          "type": "artist",
          "uri": "spotify:artist:0knGpCTbmG4ctl1wzYRZs4"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 184767,
      "explicit": false,
      "external_ids": {
        "isrc": "USWB12104062"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/0YMe6PHRbeDcN7KJdCG0bW"
      },
      "href": "https://api.spotify.com/v1/tracks/0YMe6PHRbeDcN7KJdCG0bW",
      "id": "0YMe6PHRbeDcN7KJdCG0bW",
      "is_local": false,
      "name": "The Dress",
      "popularity": 71,
      "preview_url": "https://p.scdn.co/mp3-preview/c07b57ff4552860bdfd8e32fe06c657bb64cd77f?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 6,
      "type": "track",
      "uri": "spotify:track:0YMe6PHRbeDcN7KJdCG0bW"
    },
    {
      "album": {
        "album_type": "SINGLE",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/1Xyo4u8uXC1ZmMpatF05PJ"
            },
            "href": "https://api.spotify.com/v1/artists/1Xyo4u8uXC1ZmMpatF05PJ",
            "id": "1Xyo4u8uXC1ZmMpatF05PJ",
            "name": "The Weeknd",
            "type": "artist",
            "uri": "spotify:artist:1Xyo4u8uXC1ZmMpatF05PJ"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/6DmXKM13nNgIIby2FdK0f8"
        },
        "href": "https://api.spotify.com/v1/albums/6DmXKM13nNgIIby2FdK0f8",
        "id": "6DmXKM13nNgIIby2FdK0f8",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b2733c041e53cb5c38b6de03e758",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e023c041e53cb5c38b6de03e758",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d000048513c041e53cb5c38b6de03e758",
            "width": 64
          }
        ],
        "name": "Take My Breath",
        "release_date": "2021-08-06",
        "release_date_precision": "day",
        "total_tracks": 1,
        "type": "album",
        "uri": "spotify:album:6DmXKM13nNgIIby2FdK0f8"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/1Xyo4u8uXC1ZmMpatF05PJ"
          },
          "href": "https://api.spotify.com/v1/artists/1Xyo4u8uXC1ZmMpatF05PJ",
          "id": "1Xyo4u8uXC1ZmMpatF05PJ",
          "name": "The Weeknd",
          "type": "artist",
          "uri": "spotify:artist:1Xyo4u8uXC1ZmMpatF05PJ"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 220196,
      "explicit": false,
      "external_ids": {
        "isrc": "USUG12102076"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/6OGogr19zPTM4BALXuMQpF"
      },
      "href": "https://api.spotify.com/v1/tracks/6OGogr19zPTM4BALXuMQpF",
      "id": "6OGogr19zPTM4BALXuMQpF",
      "is_local": false,
      "name": "Take My Breath",
      "popularity": 86,
      "preview_url": "https://p.scdn.co/mp3-preview/41c1390774489fbd9f129ca954c1062bb66c78e6?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 1,
      "type": "track",
      "uri": "spotify:track:6OGogr19zPTM4BALXuMQpF"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/5cj0lLjcoR7YOSnhnX0Po5"
            },
            "href": "https://api.spotify.com/v1/artists/5cj0lLjcoR7YOSnhnX0Po5",
            "id": "5cj0lLjcoR7YOSnhnX0Po5",
            "name": "Doja Cat",
            "type": "artist",
            "uri": "spotify:artist:5cj0lLjcoR7YOSnhnX0Po5"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/4XLPYMERZZaBzkJg0mkdvO"
        },
        "href": "https://api.spotify.com/v1/albums/4XLPYMERZZaBzkJg0mkdvO",
        "id": "4XLPYMERZZaBzkJg0mkdvO",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b2734c767857a41ec9da231adb6a",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e024c767857a41ec9da231adb6a",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d000048514c767857a41ec9da231adb6a",
            "width": 64
          }
        ],
        "name": "Planet Her (Deluxe)",
        "release_date": "2021-06-27",
        "release_date_precision": "day",
        "total_tracks": 19,
        "type": "album",
        "uri": "spotify:album:4XLPYMERZZaBzkJg0mkdvO"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/5cj0lLjcoR7YOSnhnX0Po5"
          },
          "href": "https://api.spotify.com/v1/artists/5cj0lLjcoR7YOSnhnX0Po5",
          "id": "5cj0lLjcoR7YOSnhnX0Po5",
          "name": "Doja Cat",
          "type": "artist",
          "uri": "spotify:artist:5cj0lLjcoR7YOSnhnX0Po5"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 216853,
      "explicit": true,
      "external_ids": {
        "isrc": "USRC12101537"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/0bOgWId7cFqBEKnlZct2q6"
      },
      "href": "https://api.spotify.com/v1/tracks/0bOgWId7cFqBEKnlZct2q6",
      "id": "0bOgWId7cFqBEKnlZct2q6",
      "is_local": false,
      "name": "Love To Dream",
      "popularity": 67,
      "preview_url": "https://p.scdn.co/mp3-preview/47ddbe66ac9ce6007364fc8f70323007318d66a7?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 7,
      "type": "track",
      "uri": "spotify:track:0bOgWId7cFqBEKnlZct2q6"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/5cj0lLjcoR7YOSnhnX0Po5"
            },
            "href": "https://api.spotify.com/v1/artists/5cj0lLjcoR7YOSnhnX0Po5",
            "id": "5cj0lLjcoR7YOSnhnX0Po5",
            "name": "Doja Cat",
            "type": "artist",
            "uri": "spotify:artist:5cj0lLjcoR7YOSnhnX0Po5"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/4XLPYMERZZaBzkJg0mkdvO"
        },
        "href": "https://api.spotify.com/v1/albums/4XLPYMERZZaBzkJg0mkdvO",
        "id": "4XLPYMERZZaBzkJg0mkdvO",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b2734c767857a41ec9da231adb6a",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e024c767857a41ec9da231adb6a",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d000048514c767857a41ec9da231adb6a",
            "width": 64
          }
        ],
        "name": "Planet Her (Deluxe)",
        "release_date": "2021-06-27",
        "release_date_precision": "day",
        "total_tracks": 19,
        "type": "album",
        "uri": "spotify:album:4XLPYMERZZaBzkJg0mkdvO"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/5cj0lLjcoR7YOSnhnX0Po5"
          },
          "href": "https://api.spotify.com/v1/artists/5cj0lLjcoR7YOSnhnX0Po5",
          "id": "5cj0lLjcoR7YOSnhnX0Po5",
          "name": "Doja Cat",
          "type": "artist",
          "uri": "spotify:artist:5cj0lLjcoR7YOSnhnX0Po5"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 172626,
      "explicit": true,
      "external_ids": {
        "isrc": "USRC12101532"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/1M3XB6EUPUZy58Aqt6zbKr"
      },
      "href": "https://api.spotify.com/v1/tracks/1M3XB6EUPUZy58Aqt6zbKr",
      "id": "1M3XB6EUPUZy58Aqt6zbKr",
      "is_local": false,
      "name": "Woman",
      "popularity": 73,
      "preview_url": "https://p.scdn.co/mp3-preview/5f583b2ce5aff7762b6611a85907d55349a62db1?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 1,
      "type": "track",
      "uri": "spotify:track:1M3XB6EUPUZy58Aqt6zbKr"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/6M2wZ9GZgrQXHCFfjv46we"
            },
            "href": "https://api.spotify.com/v1/artists/6M2wZ9GZgrQXHCFfjv46we",
            "id": "6M2wZ9GZgrQXHCFfjv46we",
            "name": "Dua Lipa",
            "type": "artist",
            "uri": "spotify:artist:6M2wZ9GZgrQXHCFfjv46we"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/0JeyP8r2hBxYIoxXv11XiX"
        },
        "href": "https://api.spotify.com/v1/albums/0JeyP8r2hBxYIoxXv11XiX",
        "id": "0JeyP8r2hBxYIoxXv11XiX",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b273ef12a4e8cdb297684e197cc4",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e02ef12a4e8cdb297684e197cc4",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d00004851ef12a4e8cdb297684e197cc4",
            "width": 64
          }
        ],
        "name": "Future Nostalgia (The Moonlight Edition)",
        "release_date": "2021-02-11",
        "release_date_precision": "day",
        "total_tracks": 19,
        "type": "album",
        "uri": "spotify:album:0JeyP8r2hBxYIoxXv11XiX"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/6M2wZ9GZgrQXHCFfjv46we"
          },
          "href": "https://api.spotify.com/v1/artists/6M2wZ9GZgrQXHCFfjv46we",
          "id": "6M2wZ9GZgrQXHCFfjv46we",
          "name": "Dua Lipa",
          "type": "artist",
          "uri": "spotify:artist:6M2wZ9GZgrQXHCFfjv46we"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 183290,
      "explicit": false,
      "external_ids": {
        "isrc": "GBAHT1901121"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/2FlcxnvybdwpaMmMhaRtSN"
      },
      "href": "https://api.spotify.com/v1/tracks/2FlcxnvybdwpaMmMhaRtSN",
      "id": "2FlcxnvybdwpaMmMhaRtSN",
      "is_local": false,
      "name": "Don't Start Now",
      "popularity": 73,
      "preview_url": "https://p.scdn.co/mp3-preview/b6f2baf2ed4a1eae6401a002f1324a2f29de81c0?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 2,
      "type": "track",
      "uri": "spotify:track:2FlcxnvybdwpaMmMhaRtSN"
    },
    {
      "album": {
        "album_type": "ALBUM",
        "artists": [
          {
            "external_urls": {
              "spotify": "https://open.spotify.com/artist/1Xyo4u8uXC1ZmMpatF05PJ"
            },
            "href": "https://api.spotify.com/v1/artists/1Xyo4u8uXC1ZmMpatF05PJ",
            "id": "1Xyo4u8uXC1ZmMpatF05PJ",
            "name": "The Weeknd",
            "type": "artist",
            "uri": "spotify:artist:1Xyo4u8uXC1ZmMpatF05PJ"
          }
        ],
        "available_markets": [
          "AD",
          "AE",
          "AR",
          "AT",
          "AU",
          "BE",
          "BG",
          "BH",
          "BO",
          "BR",
          "CA",
          "CH",
          "CL",
          "CO",
          "CR",
          "CY",
          "CZ",
          "DE",
          "DK",
          "DO",
          "DZ",
          "EC",
          "EE",
          "EG",
          "ES",
          "FI",
          "FR",
          "GB",
          "GR",
          "GT",
          "HK",
          "HN",
          "HU",
          "ID",
          "IE",
          "IL",
          "IN",
          "IS",
          "IT",
          "JO",
          "JP",
          "KW",
          "LB",
          "LI",
          "LT",
          "LU",
          "LV",
          "MA",
          "MC",
          "MT",
          "MX",
          "MY",
          "NI",
          "NL",
          "NO",
          "NZ",
          "OM",
          "PA",
          "PE",
          "PH",
          "PL",
          "PS",
          "PT",
          "PY",
          "QA",
          "RO",
          "SA",
          "SE",
          "SG",
          "SK",
          "SV",
          "TH",
          "TN",
          "TR",
          "TW",
          "US",
          "UY",
          "VN",
          "ZA"
        ],
        "external_urls": {
          "spotify": "https://open.spotify.com/album/6YlDIxqEjvY63ffH6AwCjd"
        },
        "href": "https://api.spotify.com/v1/albums/6YlDIxqEjvY63ffH6AwCjd",
        "id": "6YlDIxqEjvY63ffH6AwCjd",
        "images": [
          {
            "height": 640,
            "url": "https://i.scdn.co/image/ab67616d0000b27380880b62143e819e901d8465",
            "width": 640
          },
          {
            "height": 300,
            "url": "https://i.scdn.co/image/ab67616d00001e0280880b62143e819e901d8465",
            "width": 300
          },
          {
            "height": 64,
            "url": "https://i.scdn.co/image/ab67616d0000485180880b62143e819e901d8465",
            "width": 64
          }
        ],
        "name": "After Hours (Deluxe)",
        "release_date": "2020-04-03",
        "release_date_precision": "day",
        "total_tracks": 17,
        "type": "album",
        "uri": "spotify:album:6YlDIxqEjvY63ffH6AwCjd"
      },
      "artists": [
        {
          "external_urls": {
            "spotify": "https://open.spotify.com/artist/1Xyo4u8uXC1ZmMpatF05PJ"
          },
          "href": "https://api.spotify.com/v1/artists/1Xyo4u8uXC1ZmMpatF05PJ",
          "id": "1Xyo4u8uXC1ZmMpatF05PJ",
          "name": "The Weeknd",
          "type": "artist",
          "uri": "spotify:artist:1Xyo4u8uXC1ZmMpatF05PJ"
        }
      ],
      "available_markets": [
        "AD",
        "AE",
        "AR",
        "AT",
        "AU",
        "BE",
        "BG",
        "BH",
        "BO",
        "BR",
        "CA",
        "CH",
        "CL",
        "CO",
        "CR",
        "CY",
        "CZ",
        "DE",
        "DK",
        "DO",
        "DZ",
        "EC",
        "EE",
        "EG",
        "ES",
        "FI",
        "FR",
        "GB",
        "GR",
        "GT",
        "HK",
        "HN",
        "HU",
        "ID",
        "IE",
        "IL",
        "IN",
        "IS",
        "IT",
        "JO",
        "JP",
        "KW",
        "LB",
        "LI",
        "LT",
        "LU",
        "LV",
        "MA",
        "MC",
        "MT",
        "MX",
        "MY",
        "NI",
        "NL",
        "NO",
        "NZ",
        "OM",
        "PA",
        "PE",
        "PH",
        "PL",
        "PS",
        "PT",
        "PY",
        "QA",
        "RO",
        "SA",
        "SE",
        "SG",
        "SK",
        "SV",
        "TH",
        "TN",
        "TR",
        "TW",
        "US",
        "UY",
        "VN",
        "ZA"
      ],
      "disc_number": 1,
      "duration_ms": 250057,
      "explicit": true,
      "external_ids": {
        "isrc": "USUG12000650"
      },
      "external_urls": {
        "spotify": "https://open.spotify.com/track/3KQ1KVG2F8qAospksegrmZ"
      },
      "href": "https://api.spotify.com/v1/tracks/3KQ1KVG2F8qAospksegrmZ",
      "id": "3KQ1KVG2F8qAospksegrmZ",
      "is_local": false,
      "name": "Alone Again",
      "popularity": 60,
      "preview_url": "https://p.scdn.co/mp3-preview/cedeba253f39d8de17d0569ea5c90a863405fb59?cid=4b4f0d220f9c4eb3934cbbaadf74fe72",
      "track_number": 1,
      "type": "track",
      "uri": "spotify:track:3KQ1KVG2F8qAospksegrmZ"
    }
  ],
  "total": 12,
  "limit": 10,
  "offset": 0,
  "previous": null,
  "href": "https://api.spotify.com/v1/me/top/tracks?time_range=short_term",
  "next": "https://api.spotify.com/v1/me/top/tracks?limit=20&offset=20&time_range=short_term"
}

export default demoTopTracks;